import { PERISCOPE_TAB_TYPES } from '@sonar-software/sonar-ts-constants';
import { picklistSortOptions } from './PicklistSortOptions';
import { SelectionTable } from '@ui/tables';
import { getRowKey, paginationDefaultQueryParams, paginationFallbackQueryParams, PeriscopePagination } from '..';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { PeriscopePicklistValue, PicklistValueSearch } from '.';
import React, { useCallback, useRef } from 'react';
import { usePeriscopeActions, useQueryResource, useSelectionTable } from '@hooks';
export const SalesforcePicklistSearchableSelectionTable = ({ parentIndex, resourceIdsUri, uri }) => {
    const scrollableListRef = useRef(null);
    const { loading, resource, queryParams, updateParams } = useQueryResource({
        defaultParams: Object.assign(Object.assign({}, paginationDefaultQueryParams), { sortBy: picklistSortOptions[0].key, sortDirection: picklistSortOptions[0].direction }),
        fallbackParams: paginationFallbackQueryParams,
        uri
    });
    const selectionData = useSelectionTable({
        getRowKey,
        queryParams,
        resourceIdsUri,
        results: resource === null || resource === void 0 ? void 0 : resource.results,
        selectionType: SonarObjectType.SalesforcePicklistValue
    });
    const { openPeriscope } = usePeriscopeActions();
    const handlePicklistValueClick = useCallback((picklistValue) => {
        const { displayName, sonarObjectId } = picklistValue;
        openPeriscope({
            id: sonarObjectId,
            name: displayName,
            openedFromIndex: parentIndex,
            type: SonarObjectType.SalesforcePicklistValue
        });
    }, [openPeriscope, parentIndex]);
    const renderPicklistValue = useCallback((picklistValue) => React.createElement(PeriscopePicklistValue, { key: picklistValue.sonarObjectId, onPicklistValueClick: handlePicklistValueClick, picklistValue: picklistValue }), [handlePicklistValueClick]);
    const totalCount = resource === null || resource === void 0 ? void 0 : resource.totalCount;
    const results = resource === null || resource === void 0 ? void 0 : resource.results;
    return (React.createElement(React.Fragment, null,
        React.createElement(PicklistValueSearch, { onChange: updateParams }),
        React.createElement(SelectionTable, { dataSource: results, loading: loading, ref: scrollableListRef, renderRow: renderPicklistValue, rowKey: getRowKey, selectionData: selectionData, selectionType: PERISCOPE_TAB_TYPES.PICKLIST_VALUES }),
        React.createElement(PeriscopePagination, { loading: loading, onChange: updateParams, queryParams: queryParams, scrollRef: scrollableListRef, totalCount: Number(totalCount) })));
};
